var $34c13dbc4614b421$exports = {};
$34c13dbc4614b421$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "placeholder": `Kiv\xe1laszt\xe1s\u{2026}`
};


export {$34c13dbc4614b421$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
